<ng-template #confirmDialog let-dialogRef="dialogRef">
  <div mat-dialog-title class="dialog-header">
    <button type="button" class="close-button" (click)="dialogRef.close(false)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>

    <h4>Confirm Action</h4>
  </div>
  <mat-dialog-content>Are you sure you want to delete this item?</mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="dialogRef.close(false)">No</button>
    <button mat-button color="primary" (click)="dialogRef.close(true)">Yes</button>
  </mat-dialog-actions>
</ng-template>
<mat-card>
  <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
    <h3 class="page-header">SFTP Access</h3>
    <div class="m-gap text-right upload-csv-sftp padding-5">
      <input type="file" (change)="onFileSelected($event)" [disabled]="!selectedFolder" accept=".csv" required>
      <button mat-raised-button (click)="uploadFile()" color="primary" [disabled]="!selectedFile">Upload CSV file</button>
    </div>
  </mat-card-title>
    <mat-card-content style="min-height: 500px;">
      <mat-form-field>
        <mat-label>Select User</mat-label>
        <mat-select [(ngModel)]="selectedUser" (selectionChange)="listContents()">
          <mat-option *ngFor="let user of users" [value]="user">{{user.username}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="users?.length > 0">
        <mat-label>Select folder</mat-label>
        <mat-select [(ngModel)]="selectedFolder" (selectionChange)="selectedFolderChanged()">
          <mat-option *ngFor="let folder of folders" [value]="folder">{{folder}}</mat-option>
        </mat-select>
      </mat-form-field>

      <hr />
      <div *ngIf="users?.length === 0" >
        <h2>There are no users with sftp access</h2>
      </div>

      <table mat-table [dataSource]="dataSource" *ngIf="dataSource?.data?.length > 0">
        <ng-container matColumnDef="Key">
          <th mat-header-cell *matHeaderCellDef> File Name</th>
          <td mat-cell *matCellDef="let element">
            {{element.Key}}
          </td>
        </ng-container>
        <ng-container matColumnDef="LastModified">
          <th mat-header-cell *matHeaderCellDef> Last modified</th>
          <td mat-cell *matCellDef="let element">
            {{element.LastModified}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Size">
          <th mat-header-cell *matHeaderCellDef> Size </th>
          <td mat-cell *matCellDef="let element">
            {{element.Size}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Owner.DisplayName">
          <th mat-header-cell *matHeaderCellDef> Owner </th>
          <td mat-cell *matCellDef="let element">
            {{element.Owner?.DisplayName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <div class="buttons-wrap" style="margin-left: 20px">
              <mat-button-toggle-group>
                <mat-button-toggle class="mat-raised-button sftp-button" (click)="openConfirmDialog(element.Key)">
                  <i class="fa fa-lg fa-trash" matTooltip="Delete"></i>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-card-content>
</mat-card>
